import * as React from 'react'

import { Field, getIn, FieldProps, FormikProps } from 'formik'
import {
  CheckboxGroup,
  Checkbox,
  VerticalCheckboxGroup
} from '@espoon-voltti/react-components/elements/form'
import { fieldState, ErrorMessage } from '../formik-util'

interface FormCheckboxArrayProps {
  name: string
  children: React.ReactNodeArray
  label: React.ReactNode
  dataQa?: string
  required?: boolean
}

interface ContextType {
  value: string[]
  onChange: (c: boolean, v: string) => void
}
const ctx = React.createContext<ContextType>({
  value: [],
  onChange: () => {
    /* noop */
  }
})

const hanldeUpdate =
  (form: FormikProps<any>, name: string) => (c: boolean, v: string) => {
    const values = getIn(form.values, name) as string[]
    form.setFieldValue(name, [
      ...values.filter((x) => x !== v),
      ...(c ? [v] : [])
    ])
  }

export const FormCheckboxArray = ({
  name,
  children,
  dataQa,
  label,
  required
}: FormCheckboxArrayProps) => (
  <Field name={name}>
    {({ form, field }: FieldProps) => (
      <ctx.Provider
        value={{
          value: getIn(form.values, name),
          onChange: hanldeUpdate(form, name)
        }}
      >
        <CheckboxGroup
          dataQa={dataQa}
          label={label}
          required={required}
          state={fieldState(name, form)}
          message={<ErrorMessage name={field.name} />}
        >
          {children}
        </CheckboxGroup>
      </ctx.Provider>
    )}
  </Field>
)

export const VerticalFormCheckboxArray = ({
  name,
  children,
  dataQa,
  label,
  required
}: FormCheckboxArrayProps) => (
  <Field name={name}>
    {({ form, field }: FieldProps) => (
      <ctx.Provider
        value={{
          value: getIn(form.values, name),
          onChange: hanldeUpdate(form, name)
        }}
      >
        <VerticalCheckboxGroup
          dataQa={dataQa}
          label={label}
          required={required}
          state={fieldState(name, form)}
          message={<ErrorMessage name={field.name} />}
        >
          {children}
        </VerticalCheckboxGroup>
      </ctx.Provider>
    )}
  </Field>
)

interface CheckboxProps {
  value: string
  label: React.ReactNode
  dataQa?: string
}

export const FormArrayCheckbox = ({ label, dataQa, value }: CheckboxProps) => {
  const context = React.useContext(ctx)
  const isChecked = context.value.indexOf(value) > -1
  const handleChange = (checked: boolean) => context.onChange(checked, value)

  return (
    <Checkbox
      dataQa={dataQa}
      name={value}
      label={label}
      checked={isChecked}
      onChange={handleChange}
    />
  )
}
